import {Injectable} from '@angular/core';
import {SessionService} from 'src/app/shared/session-service/session.service';
import {API_URL} from 'src/app/shared/constants/apiurl-constants';

@Injectable({providedIn: 'root'})
export class ClientManagerSurveyListService {
  constructor(private _sessionService: SessionService) {}

  getSurveyRespondent() {
    let url = API_URL.GETSURVEYSBYRESPONDENT;
    return this._sessionService.apiUrlGet(url);
  }

  getEngagementData() {
    let url = API_URL.GETENGAGEMENTDATA;
    return this._sessionService.apiUrlGet(url);
  }
  getSMESurvey(userId) {
    let url = API_URL.GETSMESURVEYS;
    return this._sessionService.apiUrlGet(url + `?userId=${userId}`);
  }  

  private isRespondent:boolean = false;
  set isClientManagerSME(data: boolean){
    this.isRespondent = data;
  }

  get isClientManagerSME() : boolean{
    return this.isRespondent ;
  }
}
